module.exports = __webpack_public_path__ + "img/racecourse-vaal-turf-2200.16c33b73.svg";